// extracted by mini-css-extract-plugin
export var clickBlocker = "_lg-c";
export var interactivePassthrough = "_lg-4";
export var lookHere = "_lg-3";
export var modal = "_lg-e";
export var modalBackdrop = "_lg-d";
export var modalBody = "_lg-p";
export var modalBodyHero = "_lg-q";
export var modalDescription = "_lg-s";
export var modalEnter = "_lg-f";
export var modalFooter = "_lg-t";
export var modalFooterHero = "_lg-u";
export var modalHeaderText = "_lg-n";
export var modalHeroImage = "_lg-i";
export var modalHeroTitle = "_lg-l";
export var modalIconCircle = "_lg-o";
export var modalIconHeader = "_lg-m";
export var modalImageLabel = "_lg-k";
export var modalImageOverlay = "_lg-j";
export var modalImageWrapper = "_lg-h";
export var modalTitle = "_lg-r";
export var modalWithHero = "_lg-g";
export var pulse = "_lg-1";
export var pulseBorder = "_lg-2";
export var spotlight = "_lg-0";
export var tooltip = "_lg-5";
export var tooltipButtons = "_lg-a";
export var tooltipDescription = "_lg-7";
export var tooltipFooter = "_lg-8";
export var tooltipInteractiveHint = "_lg-b";
export var tooltipStepIndicator = "_lg-9";
export var tooltipTitle = "_lg-6";